import { AbstractControl, ValidationErrors } from '@angular/forms';

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  const regex = /^\d{10,11}$/; 

  if (!value) return null;
  return regex.test(value) ? null : { phoneInvalid: true };
}